var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.parsed.length > 0)?_c('div',{staticClass:"project-tags"},_vm._l((_vm.parsed),function(tag){return _c('span',{key:tag.text,staticClass:"project-tag"},[_vm._v(_vm._s(tag.text))])}),0):_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }